import React from 'react';
import { 
	func,
	object,
	string,
	oneOfType
} from 'prop-types';
import { REQUESTING } from '../../../constants';
import PlayQuizLayout from '../../templates/PlayQuizLayout';
import SingleContentLayout from '../../templates/SingleContentLayout';
import QuizContent from '../../organisms/QuizContent/index';
import ErrorPage from '../ErrorPage/index';
import Loading from '../../atoms/Loading';

const PlayQuizPage = ({recipe, onSubmit, onDiscard, answers, fetchingState, error, errorMessage})=>{
	if( fetchingState===REQUESTING.FETCHING ) {
		return <SingleContentLayout  
			render={()=><Loading />} 
		/>;
	}
	if(error){
		return <ErrorPage message={errorMessage} error={error}
		/>;
	}
	return <PlayQuizLayout 
		renderContent={()=><QuizContent 
			recipe={recipe}
			onSubmit={onSubmit}
			onDiscard={onDiscard}
			answers={answers}
		/>}
	/>;
};

PlayQuizPage.propTypes = {
	recipe : object,
	answers : object,
	fetchingState : string,
	error : oneOfType([string,object]),
	onSubmit : func,
	onDiscard : func,
	errorMessage : string
};

export default PlayQuizPage;